import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { formatCurrency, formatPercent } from '@/lib/format';
import type { ChartDataItem, ChartTooltipProps } from '@/types/charts';

interface CategoryPieChartProps {
  /** Each item carries its own `fill`: the category's colour (getCategoryColorHsl), the same dot as on Categorias. */
  data: ChartDataItem[];
}

const FALLBACK_FILL = 'hsl(var(--muted-foreground))';

const CustomTooltip = ({ active, payload }: ChartTooltipProps) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload as ChartDataItem;
    return (
      <div className="bg-popover border border-border rounded-lg shadow-lg p-3">
        <p className="font-medium">{data.name}</p>
        <p className="text-sm text-muted-foreground">
          {data.percentage === undefined
            ? formatCurrency(data.value)
            : `${formatCurrency(data.value)} (${formatPercent(data.percentage)})`}
        </p>
      </div>
    );
  }
  return null;
};

export const CategoryPieChart: React.FC<CategoryPieChartProps> = ({ data }) => {
  return (
    <div className="h-[200px] w-[200px]">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={50}
            outerRadius={80}
            paddingAngle={2}
            dataKey="value"
          >
            {data.map((item) => (
              <Cell key={item.name} fill={item.fill ?? FALLBACK_FILL} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
